import { render, staticRenderFns } from "./FinishedEvaluations.vue?vue&type=template&id=a0bad81e&"
import script from "./FinishedEvaluations.vue?vue&type=script&lang=js&"
export * from "./FinishedEvaluations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports